<template>
  <div class="view-box">
    <!-- 加载状态 -->
    <div
      style="
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 999999;
        display: flex;
        justify-content: center;
        align-items: center;
      "
      v-show="loading"
    >
      <van-loading color="#1989fa" />
    </div>
    <img src="../assets/img/headerImg.png" class="view-box" />
    <!-- 上传照片 -->
    <div class="content-box">
      <div class="content-box-2">
        <h6 class="title-1">请上传正面照</h6>
        <van-uploader
          v-model="fileList"
          :after-read="imgAfterRead"
          preview-size="260px"
          :max-count="1"
          :capture="!$route.query.addRelation ? 'camera' : null"
          ref="imgBox"
        >
          <!-- <template>
            <div class="preview-cover van-ellipsis">点击上传图片</div>
          </template> -->
        </van-uploader>
      </div>
      <p class="title-2">注：正面照片不要有口罩、帽子等遮挡物</p>
    </div>
    <div class="submit-box">
      <van-button plain type="info" class="width-46b" @click="pictureBack"
        >上一步</van-button
      >
      <van-button type="info" class="width-46b" @click="infoSubmit"
        >提交</van-button
      >
    </div>
  </div>
</template>

<script>
import { upLoadInfoAPI } from "@/server/api";
import { mapGetters } from "vuex";
import { Uploader, Button, Notify, Loading } from "vant";
export default {
  name: "pictureInfo",
  components: {
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    [Notify.name]: Notify,
    [Loading.name]: Loading,
  },
  data() {
    return {
      loading: false, // 加载状态
      fileList: [], // 上传的图片
    };
  },
  computed: {
    ...mapGetters(["baseInfo", "userId", "pictureInfo", "pictureFile"]),
  },
  watch: {
    fileList(newData) {
      if (newData.length < 1) {
        this.$store.commit("setPictureInfo", "");
        this.$store.commit("setPictureFile", "");
      }
    },
  },
  activated() {
    if (this.pictureInfo) {
      this.fileList = [
        {
          url: this.pictureInfo,
          isImage: true,
        },
      ];
    } else if (this.pictureFile) {
      let reader = new FileReader(); //实例化文件读取对象
      reader.readAsDataURL(this.pictureFile); //将文件读取为 DataURL,也就是base64编码
      reader.onload = (ev) => {
        //文件读取成功完成时触发
        let dataURL = ev.target.result; //获得文件读取成功后的DataURL,也就是base64编码
        this.fileList = [
          {
            url: dataURL,
            isImage: true,
          },
        ];
      };
    } else {
      this.fileList = [];
    }
  },
  mounted() {},
  methods: {
    // 将base64转换为file文件
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    // 图片上传钩子
    imgAfterRead(file) {
      let imgMaxSize = 1 * 1024 * 500; // 500KB
      // 大于1MB时压缩图片
      if (file.file.size > imgMaxSize) {
        let canvas = document.createElement("canvas"); // 创建Canvas对象(画布)
        let context = canvas.getContext("2d");
        let img = new Image();
        img.src = file.content; // 指定图片的DataURL(图片的base64编码数据)
        img.onload = () => {
          canvas.width = 400;
          canvas.height = 400;
          context.drawImage(img, 0, 0, 400, 400);
          file.content = canvas.toDataURL(file.file.type, 0.92); // 0.92为默认压缩质量
          let newFile = this.dataURLtoFile(file.content, file.file.name);
          this.upLoadImg(newFile);
        };
      } else {
        this.upLoadImg(file.file);
      }
    },
    // 上传图片
    upLoadImg(file) {
      this.$store.commit("setPictureFile", file);
      // let params = new FormData();
      // params.append("image", file);
      // upLoadImgAPI(params)
      //   .then((res) => {
      //     const { code, data, msg } = res.data;
      //     if (code === 200) {
      //       this.$store.commit("setPictureInfo", data);
      //     } else {
      //       Notify({ type: "warning", message: msg });
      //     }
      //   })
      //   .catch((err) => {
      //     Notify({ type: "danger", message: err.message });
      //   });
    },
    // 返回
    pictureBack() {
      if (this.$route.query.addRelation) {
        this.$router.push({
          path: "/registrationInfo",
          query: {
            addRelation: 1,
          },
        });
      } else {
        this.$router.push({
          path: "/registrationInfo",
        });
      }
    },
    // 提交信息
    infoSubmit() {
      if (this.fileList.length < 1) {
        Notify({ type: "warning", message: "请先上传照片" });
      } else {
        this.loading = true;
        let params = new FormData();
        params.append("new_person_id", this.userId);
        params.append("name", this.baseInfo.name);
        params.append("idcard", this.baseInfo.IdNumber);
        params.append("phone", this.baseInfo.tel);
        params.append(
          "pic",
          this.pictureInfo
            ? this.dataURLtoFile(this.pictureInfo, "img")
            : this.pictureFile
        );
        params.append(
          "full_addr",
          JSON.stringify(
            Object.assign(this.baseInfo.housingInfo, {
              building: this.baseInfo.area.areaOne,
              unit: this.baseInfo.area.areaTwo,
              number: this.baseInfo.area.areaThree,
            })
          )
        );
        params.append("write_person_idcard", this.baseInfo.IdNumber);
        params.append("whcd", this.baseInfo.educationId);
        params.append("zzmm", this.baseInfo.politicsId);
        params.append("zzsy", this.baseInfo.dwellReasonId);
        params.append("gzcs", this.baseInfo.company);
        params.append("expire_date", this.baseInfo.dwellDate);
        if (this.$route.query.addRelation) {
          params.append("is_inmate", 1);
        }
        upLoadInfoAPI(params)
          .then((res) => {
            this.loading = false;
            const { code, msg } = res.data;
            if (code === 200) {
              this.$router.push({
                path: "/enrolled",
              });
            } else {
              Notify({ type: "warning", message: msg });
            }
          })
          .catch((err) => {
            this.loading = false;
            Notify({ type: "danger", message: err.message });
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.preview-cover {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  padding: 4px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background: rgba(0, 0, 0, 0.3);
}
/deep/ .van-uploader__preview-delete {
  width: 50px;
  height: 28px;
  border-radius: 0;
}
/deep/ .van-uploader__preview-delete-icon {
  font-size: 0px;
}
/deep/ .van-uploader__preview-delete-icon:after {
  content: "删除";
  font-size: 26px;
  color: #fff;
}
/deep/ .van-uploader__upload-icon:after {
  content: "点击拍照";
  display: block;
  font-size: 16px;
  color: #444;
}
.width-46b {
  width: 46%;
}
.content-box {
  width: 100%;
  background: #fff;
  padding: 0.8rem 1.6rem;
  .content-box-2 {
    width: 100%;
    text-align: center;
    .title-1 {
      text-align: left;
      font-size: 1.4rem;
      color: #333;
      margin-bottom: 2rem;
      font-weight: normal;
    }
  }
  .title-2 {
    font-size: 1.4rem;
    color: #777;
    margin-top: 1rem;
  }
}
.submit-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.8rem 1.6rem;
  background: #fff;
  box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: space-between;
}
</style>
